// Mock API for demo/testing mode - returns static sample data without hitting backend

export const fetchTareasRegistros = async () => ([
  {
    id: 't1',
    name: 'Checklist apertura',
    tipo_datos: 'checklist',
    periodicidad: 'diaria',
    dias_semana: 'lunes,martes,miercoles,jueves,viernes',
    categoria: 'Operativa',
    fk_checklist: 'chk-1',
    checklist: [{ id: 'chk-1', nombre: 'Apertura' }],
  },
  {
    id: 't2',
    name: 'Control temperaturas',
    tipo_datos: 'registro',
    periodicidad: 'diaria',
    dias_semana: 'lunes,martes,miércoles,jueves,viernes,sábado,domingo',
    categoria: 'Calidad',
  },
  {
    id: 't3',
    name: 'Limpieza semanal',
    tipo_datos: 'checklist',
    periodicidad: 'semanal',
    dias_semana: 'viernes',
    categoria: 'Limpieza',
    fk_checklist: 'chk-2',
    checklist: [{ id: 'chk-2', nombre: 'Limpieza' }],
  },
]);

export const fetchTareasRegistrosWithChecklist = async () => fetchTareasRegistros();

export const fetchActivos = async () => ([
  { id: 'a1', nombre: 'Cámara 1', categoria: 'Frío', unidad: 'ºC' },
  { id: 'a2', nombre: 'Horno', categoria: 'Calor', unidad: 'ºC' },
  { id: 'a3', nombre: 'Nevera bebidas', categoria: 'Frío', unidad: 'ºC' },
]);

export const fetchCategoriaActivos = async () => ([
  { id: 'c1', nombre: 'Frío', orden: 1 },
  { id: 'c2', nombre: 'Calor', orden: 2 },
]);

export const fetchCategoriaProfesional = async () => ([
  { id: 'cp1', nombre: 'Cocina', orden: 1 },
  { id: 'cp2', nombre: 'Sala', orden: 2 },
]);

export const fetchCategoriaProfesionalGrupos = async () => ([
  { nombre: 'Cocina', orden: 1, profesionales: ['Chef', 'Ayudante'] },
  { nombre: 'Sala', orden: 2, profesionales: ['Camarero', 'Runner'] },
]);

export const fetchCategorias = async () => ([
  { id: 'cat1', nombre: 'Operativa', orden: 1 },
  { id: 'cat2', nombre: 'Calidad', orden: 2 },
  { id: 'cat3', nombre: 'Limpieza', orden: 3 },
]);

export const fetchEquipos = async () => ([
  { id: 'eq1', nombre: 'Restaurante' },
  { id: 'eq2', nombre: 'Take Away' },
]);

export const fetchPlanes = async () => ([
  { id: 'p1', nombre: 'Plan APPCC' },
  { id: 'p2', nombre: 'Plan Limpieza' },
]);

export const fetchTipologiasCentro = async () => ([
  { id: 'tp1', nombre: 'Restaurante' },
  { id: 'tp2', nombre: 'Cafetería' },
]);

export const fetchChecklists = async () => ([
  { id: 'chk-1', nombre: 'Apertura' },
  { id: 'chk-2', nombre: 'Limpieza' },
]);

export const fetchInstancias = async () => ([
  { id: 'demo', nombre: 'Instancia Demo', descripcion: 'Datos locales' },
]);
